import React from 'react';
import { styled } from '@mui/material/styles';
import { Typography } from '@mui/material';
import { NODE_UI, stopPropagation } from './nodeUiStyles';

/**
 * NodeColumnValueEditor — Column name + type icon + value MentionEditor per database column.
 * Used by: Create DB Record, Update DB Record.
 *
 * The caller provides renderValue for the actual value editor
 * (typically NodeMentionEditor or NodeChipInput depending on column type).
 */

const Root = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: 4,
  padding: `${NODE_UI.spacing.sm} ${NODE_UI.spacing.md}`,
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: NODE_UI.borderRadiusSm,
  backgroundColor: theme.palette.background.paper,
}));

const ColumnHeader = styled('div')({
  display: 'flex',
  alignItems: 'center',
  gap: 6,
});

const ColumnName = styled(Typography)(({ theme }) => ({
  fontSize: NODE_UI.fontSize.value,
  fontWeight: NODE_UI.fontWeight.label,
  color: theme.palette.text.primary,
}));

const ColumnType = styled(Typography)(({ theme }) => ({
  fontSize: NODE_UI.fontSize.caption,
  color: theme.palette.text.secondary,
  textTransform: 'uppercase',
}));

const NodeColumnValueEditor = React.memo(function NodeColumnValueEditor({
  columnName,
  columnType,
  typeIcon,
  renderValue,
  value,
  onChange,
  sx,
}) {
  return (
    <Root onMouseDown={stopPropagation} onClick={stopPropagation} onPointerDown={stopPropagation} sx={sx}>
      <ColumnHeader>
        {typeIcon}
        <ColumnName>{columnName}</ColumnName>
        {columnType && <ColumnType>{columnType}</ColumnType>}
      </ColumnHeader>
      <div>
        {renderValue
          ? renderValue({ value, onChange })
          : null
        }
      </div>
    </Root>
  );
});

export default NodeColumnValueEditor;
